/**
 * Является ли браузер IE11
 * @type {Boolean}
 */
export const isIE11 = new RegExp(/Trident.*rv[ :]*11\./).test(window.navigator.userAgent)

/**
 * Является ли браузер Firefox
 * @type {Boolean}
 */
export const isFirefox = new RegExp(/Firefox/).test(window.navigator.userAgent)
